import styled from 'styled-components'
import {getStatusColor} from 'shared/utils/statusUtils'

const Style = {
	Container: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 16px;
		padding: 16px;
		background-color: ${({theme}) => theme.color.white || '#FFFFFF'};
		border: 1px solid
			${({can_eliminate, theme}) =>
				can_eliminate ? theme.color.major : theme.color.grey3 || '#B2B2B2'};
		border-radius: 16px;
		align-self: stretch;
		width: 100%;
		box-sizing: border-box;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			padding: 12px;
			gap: 12px;
		}
	`,

	ContentContainer: styled.div`
		display: flex;
		flex-direction: column;
		gap: 6px;
		width: 100%;
		align-self: stretch;
	`,

	NameRow: styled.div`
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 6px;
		width: 100%;
		align-self: stretch;
		min-height: 14px;
	`,

	TournamentName: styled.p`
		${({theme}) => theme.font.extra_small_bold || theme.font.small};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		font-size: 12px;
		font-weight: 700;
		line-height: 1.2;
		flex: 1;
	`,

	BadgesContainer: styled.div`
		display: flex;
		align-items: center;
		gap: 6px;
		flex-shrink: 0;
		width: fit-content;
	`,

	StatusBadge: styled.div.withConfig({
		shouldForwardProp: (prop) => prop !== 'statusColor',
	})`
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 4px 6px;
		background-color: ${({statusColor, theme}) =>
			getStatusColor(statusColor, theme)};
		border-radius: 99px;
		width: fit-content;
	`,

	StatusText: styled.span.withConfig({
		shouldForwardProp: (prop) => prop !== 'statusColor',
	})`
		${({theme}) => theme.font.tiny || theme.font.extra_small};
		color: ${({theme}) => theme.color.white || '#FFFFFF'};
		font-size: 8px;
		font-weight: 400;
		line-height: 1.2;
		text-align: center;
	`,

	InfoContainer: styled.div`
		display: flex;
		flex-direction: column;
		gap: 6px;
		width: 100%;
		align-self: stretch;
	`,

	InfoRow: styled.div.withConfig({
		shouldForwardProp: (prop) => prop !== 'hidden' && prop !== 'highlight',
	})`
		display: flex;
		align-items: center;
		gap: 8px;
		width: 100%;
		align-self: stretch;
		${({hidden}) => hidden && 'display: none;'};
	`,

	IconContainer: styled.div`
		display: flex;
		align-items: center;
		justify-content: center;
		width: 16px;
		height: 16px;
		flex-shrink: 0;
	`,

	InfoText: styled.span`
		${({theme}) => theme.font.extra_small || theme.font.small};
		color: ${({theme, highlight}) =>
			highlight
				? theme.color.major || '#ED3241'
				: theme.color.black || '#1F2024'};
		font-size: 12px;
		font-weight: 400;
		line-height: 1.2;
		text-align: center;
	`,

	ButtonsContainer: styled.div`
		display: flex;
		justify-content: stretch;
		align-items: stretch;
		gap: 16px;
		width: 100%;
		align-self: stretch;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			gap: 12px;
		}
	`,
	SubText: styled.p`
		${({theme}) => theme.font.extra_small || theme.font.small};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		font-size: 12px;
		font-weight: 400;
		line-height: 1.2;
		text-align: center;
		margin: 0 auto 8px auto;
	`,

	NoteText: styled.p`
		${({theme}) => theme.font.extra_small || theme.font.small};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		font-size: 12px;
		font-weight: 400;
		line-height: 1.2;
		text-align: center;
		margin: 0 auto 0 auto;
	`,

	ActionButton: styled.button`
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 10px;
		padding: 8px 16px;
		background-color: ${({theme}) => theme.color.major || '#ED3241'};
		border: none;
		border-radius: 6px;
		flex: 1;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			background-color: ${({theme}) => theme.color.major || '#ED3241'};
			opacity: 0.9;
			transform: translateY(-1px);
		}

		&:active {
			transform: translateY(0);
		}

		&:disabled {
			background-color: ${({theme}) => theme.color.grey3 || '#B2B2B2'};
			cursor: not-allowed;
			transform: none;
		}

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			padding: 6px 12px;
		}
	`,

	ButtonText: styled.span`
		${({theme}) => theme.font.extra_small_bold || theme.font.small};
		color: ${({theme}) => theme.color.white || '#FFFFFF'};
		font-size: 12px;
		font-weight: 700;
		line-height: 1.2;
		text-align: center;
	`,
}

export default Style
